import { Drawer as MuiDrawer } from '@mui/material'
import { CSSObject, Theme, styled } from '@mui/material/styles'

const isCypress = typeof window !== 'undefined' && 'Cypress' in window

export const closedWidth = isCypress ? 81 : 44
/** Rail width from 1920px viewport width on. */
export const closedWidthWide = isCypress ? 81 : 52

const paperMixin = (theme: Theme): CSSObject => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignItems: 'center',
  height: `calc(100% - ${theme.distances.navBarHeight})`,
  top: theme.distances.navBarHeight,
  paddingTop: theme.spacing(0.5),
  background: '#fff',
  borderRight: `1px solid ${theme.palette.divider}`,
  boxShadow: 'none',
  '@media (min-width: 1920px)': {
    height: `calc(100% - ${theme.distances.navBarHeightExpanded})`,
    top: theme.distances.navBarHeightExpanded,
  },
})

const closedMixin = (): CSSObject => ({
  overflowX: 'hidden',
  width: closedWidth,
  '@media (min-width: 1920px)': {
    width: closedWidthWide,
  },
})

export const Drawer = styled(MuiDrawer, {
  shouldForwardProp: prop => prop !== 'transparent',
})<{
  transparent: boolean
}>(({ theme: _theme }) => ({
  position: 'fixed',
  zIndex: 1,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  ...closedMixin(),
  '& .MuiDrawer-paper': {
    ...closedMixin(),
    ...paperMixin(_theme),
  },
}))
